export default [
  {
    position: "absolute",
    top: 4.3,
    left: 92,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "handbook.persona1.mTitleOne",
    mBody: "handbook.persona1.mBodyOne",
    id: "OB_StaffHandbook_Info_VitalInformation",
    infoIcon: true,
    isAction: false,
    index: 0,
  },
  {
    position: "absolute",
    top: 2.5,
    left: 5.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "handbook.persona1.ttTextOne",
    hover: false,
    id: "OB_StaffHandbook_Navigation_Homepage",
    index: 1,
  },
  {
    position: "absolute",
    top: 1.8,
    left: 32.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "handbook.persona1.ttTextTwo",
    hover: false,
    id: "OB_StaffHandbook_Navigation_PersonalDetails",
    index: 2,
  },
  {
    position: "absolute",
    top: 1.8,
    left: 60.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 4,
    tooltipText: "handbook.persona1.ttTextThree",
    hover: false,
    id: "OB_StaffHandbook_Navigation_Policies",
    index: 3,
  },
  {
    position: "absolute",
    top: 1.8,
    left: 69.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "handbook.persona1.ttTextFour",
    hover: false,
    id: "OB_StaffHandbook_Navigation_Feedback",
    index: 4,
  },
  {
    position: "absolute",
    top: 0.2,
    left: 87,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 8,
    tooltipText: "handbook.persona1.ttTextFive",
    hover: false,
    tooltipClass: "left",
    id: "OB_StaffHandbook_Navigation_Actions",
    index: 5,
  },
];
